module.exports = new __parcel__URL__("chartTimelineVariantShimmer.5bfb1732.png").toString();